import { UserStatusEnum } from '../types/Enums';

/**
 * Check if user status is subscribed
 *
 * @param userStatus - user status
 * @returns True if user status is subscribed, false otherwise
 */
export function isUserStatusSubscribed(userStatus: string) {
  return userStatus === UserStatusEnum.SUBSCRIBED ? true : false;
}

/**
 * Check if user status is free
 *
 * @param userStatus - user status
 * @returns True if user status is free, false otherwise
 */
export function isUserStatusFree(userStatus: string) {
  return userStatus === UserStatusEnum.FREE ? true : false;
}

/**
 * Check if user status is new
 *
 * @param userStatus - user status
 * @returns True if user status is new, false otherwise
 */
export function isUserStatusNew(userStatus: string) {
  return userStatus === UserStatusEnum.NEW ? true : false;
}

/**
 * Check if user status is inactive
 *
 * @param userStatus - user status
 * @returns True if user status is inactive, false otherwise
 */
export function isUserStatusInactive(userStatus: string) {
  return userStatus === UserStatusEnum.INACTIVE ? true : false;
}
